import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type CustomerState = {
  customer: string;
  isGreensCustomer: boolean;
  isGermanCustomer: boolean;
};

const useCustomerStore = create<CustomerState>()(
  devtools(() => ({
    customer: 'core',
    isGreensCustomer: false,
    isGermanCustomer: false,
  }))
);

export default useCustomerStore;
